import _ from "lodash";
import { replaceWithParentTests } from ".";
import { handleBulletListPackageTests } from "../testAndPanelSelection/handleDuplicateTests";
import { 
  DBS_ANY_THREE_BUNDLE_ID,
  DBS_ANY_FIVE_BUNDLE_ID,
  HEAVY_METAL_TEST_ID,
  HEAVY_METAL_SPECIAL_PRICE,
  ANY_FIVE_QUANTITY,
  ANY_THREE_QUANTITY,
  ANY_FIVE_PLUS_THREE,
} from "./bestDealConstants";
import { tryBuildFixedDbsCombo } from "./bestDealSpecialCases";

export const bundleReplacingFuncDBS = ( allSuggestions,newValueIds,vaTestList,vwTestList, isDbs, testNodeList, x_choose_y_map, zoomer_main_price_info, zoomer_supplement_price_info, isHeavyMetalSpecialPrice ) => {
    // Special case: exact-match fixed set => return predefined Any3 + Any5 combo
    const fixedResult = tryBuildFixedDbsCombo(
      allSuggestions,
      newValueIds,
      vaTestList,
      vwTestList,
      testNodeList,
      isHeavyMetalSpecialPrice
    );
    if (fixedResult) return fixedResult;

  allSuggestions = allSuggestions.filter(function(element) {
    return element !== undefined && !!element;
  });
  if (_.isEmpty(allSuggestions)) {
    return {};
  }
  // add bundle content ids to each suggestion
  allSuggestions = allSuggestions.map((i) => {
    if (i.bundleId < 0) {
      // for seasonal promos
      return {
        bundleId: i.bundleId,
        name: i.name,
        originPrice: i.originPrice,
        finalPrice: i.finalPrice,
        bundleContentIds: i.testIdsInPromo,
        quantity: i.quantity,
        supplementList: i.supplementList
      }
    }
    return {
      bundleId: i.bundleId,
      name: i.name,
      originPrice: i.originPrice,
      finalPrice: i.finalPrice,
      bundleContentIds: i.bundleContentIds,
      quantity: i.quantity,
      supplementList: i.supplementList
    };
  });

  let anyThreePromo = allSuggestions.find(i => i.bundleId === DBS_ANY_THREE_BUNDLE_ID)
  let anyFivePromo = allSuggestions.find(i => i.bundleId === DBS_ANY_FIVE_BUNDLE_ID) 
  let anyThreePromoPrice = anyThreePromo && anyThreePromo.finalPrice
  let anyFivePromoPrice = anyFivePromo && anyFivePromo.finalPrice
  let anyThreePromoTestIds = anyThreePromo ? anyThreePromo.bundleContentIds : []

  let zoomerPriceInfo = zoomer_main_price_info
  let supplementPriceInfo = zoomer_supplement_price_info
  let zoomerIds = zoomerPriceInfo.map(zoomer => zoomer.zoomerId)
  let supplementIds = supplementPriceInfo.map(supplement => supplement.supplementId)
  // remove bundles that bundle price is larger than original price
  // note x choose y bundles origin price is null
  allSuggestions = allSuggestions.filter((i) => i.originPrice >= i.finalPrice);

  const lookup = allSuggestions.reduce((a, e) => {
    a[e.bundleId] = ++a[e.bundleId] || 0;
    return a;
  }, {});

  // edge case. do not ignore bundles that only contain one test 
  allSuggestions.forEach(i => {
    if(i.bundleContentIds.length === 1) {
      // any number large than 0 works
      lookup[i.bundleId] = 2;
    }
  })

  allSuggestions = allSuggestions.filter(i => {
    return i.bundleContentIds.every(id => newValueIds.includes(id))
    }
  )

  // find unique suggest bundles ids that has showed up more than twice
  // to reduce the computation. There is no need to consider bundles that
  // only suggested once since only one test suggest that bundle
  let uniqueDuplicateSuggestions = allSuggestions.filter(
    (e) => lookup[e.bundleId]
  );
  const key = "bundleId";
  uniqueDuplicateSuggestions = [
    ...new Map(
      uniqueDuplicateSuggestions.map((item) => [item[key], item])
    ).values(),
  ];

  // make sure every time, no matter the test add order, the suggestion is constant
  // specially for the same price which one to suggest situation
  newValueIds = newValueIds.sort((a, b) => a - b);
  let bundleCombinationsQueue = [];
  let bundleCombinationRecorded = [];

  uniqueDuplicateSuggestions = uniqueDuplicateSuggestions.filter(function(x) {
    return x !== undefined;
  });

  // initiate the queue
  bundleCombinationsQueue.push({
    appliedBundles: [],
    remainingNewValues: newValueIds,
    remainingBundles: uniqueDuplicateSuggestions
      .filter((a) => a.bundleContentIds.every(test => newValueIds.includes(test))),
    key: ""
  });

  let visited = new Set();
  while (bundleCombinationsQueue.length > 0) {
    let element = bundleCombinationsQueue.shift();
    if (visited.has(element.key)) {
      continue
    }

    visited.add(element.key)

    let remainingBundles = element.remainingBundles
      .filter((a) => !element.appliedBundles.some((b) => a.bundleId === b.bundleId)) // all remaining bundles
      .filter((a) => a.bundleContentIds.every(test => element.remainingNewValues.includes(test)))

    if (remainingBundles.length === 0) {
      bundleCombinationRecorded.push(element);
      continue;
    }
    for (let i = 0; i < remainingBundles.length; i++) {
      let isAddBundle = remainingBundles[i];
      // convert queue to set
      let combinedBundles = {
        appliedBundles: [...element.appliedBundles, isAddBundle],
      };
      
      let combinedBundlesKey = getKey(combinedBundles);
      if (visited.has(combinedBundlesKey)) {
        continue;
      }

      // remaining new values length larger or equal to 1 will consider bundle only contain one test
      if (element.remainingNewValues.length >= 1) {
          combinedBundles.remainingNewValues = element.remainingNewValues.filter(
            (x) => !isAddBundle.bundleContentIds.includes(x)
          );
          combinedBundles.remainingBundles = remainingBundles
          combinedBundles.key = combinedBundlesKey
          bundleCombinationsQueue.push(combinedBundles)
      } 
    }
  }

  // discard duplicate recorded combinatins
  let unique = new Map();
  function getKey(obj) {
    let bundleIds = [];
    for (let i = 0; i < obj.appliedBundles.length; i++) {
      bundleIds.push(obj.appliedBundles[i].bundleId);
    }
    bundleIds.sort((a, b) => a - b);
    let bundleIdStrings = bundleIds.map((i) => i.toString()).join(",");
    return bundleIdStrings;
  }
  for (let i = 0; i < bundleCombinationRecorded.length; i++) {
    if (!unique.has(getKey(bundleCombinationRecorded[i]))) {
      let key = getKey(bundleCombinationRecorded[i]);
      let value = bundleCombinationRecorded[i];
      unique.set(key, value);
    }
  }
  let suggestBundleInfo = [...unique.values()];

  // Check VP 1931: Since we process regular bundle formation first and then use leftover tests
  // to form the x choose y method, this is a temporary workaround to fix a specific case: vp 1931
  // where some tests are already formed in the above regular bundle process 
  // (e.g., Bundle A price $150: test1, test2; Bundle B price $150: test 3, test 4) 
  // and thus unable to have the opportunity to form the x choose y bundle
  // (e.g. the final return should be:
  // x choose y bundle price $100: test 1, test 3, test 4 + test 2 price $10 = $110). 
  for(let i = 0;i < uniqueDuplicateSuggestions.length; i++) {
    suggestBundleInfo.push({
      appliedBundles: [uniqueDuplicateSuggestions[i]],
      remainingNewValues: newValueIds.filter(x => !uniqueDuplicateSuggestions[i].bundleContentIds.includes(x))
    });
  }

  // provide no applied bundle option to x choose y
  suggestBundleInfo.push({
    appliedBundles: [],
    remainingNewValues: newValueIds,
  });

  // use dbs x_choose_y_map info from backend
  let xChooseYMapImported = x_choose_y_map
  let sortedAvailableQuantities = Object.keys(xChooseYMapImported).sort((a,b) => a-b)

  suggestBundleInfo = suggestBundleInfo.map((i) => {
    const selectedZoomers = _.intersection(i.remainingNewValues, zoomerIds);
    const selectedSups = _.intersection(i.remainingNewValues,supplementIds);
    let selectedZoomerSortByPrice = zoomerPriceInfo.filter(i => selectedZoomers.includes(i.zoomerId))
      .sort((a,b) => a.price - b.price)
    let selectedSupSortByPrice = supplementPriceInfo.filter(i => selectedSups.includes(i.supplementId))
      .sort((a,b) => a.price - b.price)

    // compare xChoosey price + leftover zoomers price + leftover supplement price
    // with each permutation
    // eg. when user select 9 zoomers + 2 supplement, comapre the price of: 
    // xchoose9 plan: 
    // (plan 1: xchoose4,xchoose5 with 0 supplement fee, 
    // plan 2: xcoose9 with 1 supplement fee), 
    // xchoose8 plan + 1 cheapest zoomer: 
    // (plan 1: xchoose8 with 1 supplement fee)
    // xchoose7 plan + 2 cheapest zoomers
    // and so on...
    // xchoose8 plan + 1 cheapest zoomer can be cheaper than xchoose9 plan
    // if cheapest zoomer is $0, so loop all the available xchoosey plan is necessary

    let bestXChooseYBundleCombination = {}
    for(let i = 0;i<sortedAvailableQuantities.length;i++) {
      let chosenQuantity = sortedAvailableQuantities[i]
      if(chosenQuantity > selectedZoomers.length) {
        break
      } else {
        let leftOverZoomerAmount = selectedZoomers.length - chosenQuantity
        let permutationListForYZoomers = xChooseYMapImported[chosenQuantity]

        for(let i = 0;i<permutationListForYZoomers.length;i++) {
          let leftOverSupAmount = selectedSups.length - 
            permutationListForYZoomers[i].freeSupplementAmount > 0
            ? selectedSups.length - permutationListForYZoomers[i].freeSupplementAmount 
            : 0

          let finalPriceWithSupFee = permutationListForYZoomers[i].permuFinalPrice + 
            _.sum(selectedZoomerSortByPrice.slice(0,leftOverZoomerAmount).map(i => i.price)) + 
            _.sum(selectedSupSortByPrice.slice(0,leftOverSupAmount).map(i => i.price))
          if(_.isEmpty(bestXChooseYBundleCombination) || 
            bestXChooseYBundleCombination.finalPriceWithSupFee > finalPriceWithSupFee) {
            bestXChooseYBundleCombination = {
              selectedBundle:permutationListForYZoomers[i].selectedBundle,
              finalPriceWithSupFee:finalPriceWithSupFee,
              carriedSupCount: selectedSups.length - leftOverSupAmount,
              leftOverZoomerAmount: leftOverZoomerAmount
            }
          }
        }
      }
    }
  

    let appliedXChooseY = []
    let appliedZoomerAndSupIds = []
    let appliedZoomerIndex = bestXChooseYBundleCombination.leftOverZoomerAmount
    let appliedSupIndex = selectedSups.length - bestXChooseYBundleCombination.carriedSupCount

    if(bestXChooseYBundleCombination.selectedBundle) {
      for(let i = 0;i<bestXChooseYBundleCombination.selectedBundle.length;i++) {
        let currentBundle = bestXChooseYBundleCombination.selectedBundle[i]
        appliedXChooseY.push({
          quantity: currentBundle.quantity,
          bundleId: currentBundle.bundleId,
          appliedZoomers: selectedZoomerSortByPrice
            .slice(appliedZoomerIndex,appliedZoomerIndex+currentBundle.quantity)
            .map(i => i.zoomerId),
          appliedSupplement: selectedSupSortByPrice
            .slice(appliedSupIndex,appliedSupIndex + currentBundle.freeSupplementAmount)
            .map(i => i.supplementId),
          finalPrice: currentBundle.finalPrice,
        })
        appliedZoomerIndex += currentBundle.quantity
        appliedSupIndex += currentBundle.freeSupplementAmount
        appliedZoomerAndSupIds = [
          ...appliedZoomerAndSupIds,
          ...appliedXChooseY[i].appliedZoomers,
          ...appliedXChooseY[i].appliedSupplement
        ]
      }
    }   
    return {
      appliedBundles: [...i.appliedBundles, ...appliedXChooseY],
      remainingNewValues: i.remainingNewValues.filter((x) => 
        !appliedZoomerAndSupIds.includes(x)
      ),
    };
  })
  
  suggestBundleInfo = suggestBundleInfo.map((suggestion) => {
    let remainingNewValues = replaceWithParentTests(suggestion.remainingNewValues,testNodeList)
    handleBulletListPackageTests(testNodeList, remainingNewValues)
    /** 
     * comment out following code
     * @reason any3 or any5 promo no need the following restrictions: only descendants from different roots cam form any3 or any5 promo
     * @date update on 01/06/2024
     */
    // only descendants from different types of roots can form an any3 or any 5 promo
    // if two descendants are selected from the same root, they cannot form an any 3 promo 
    // let completeFoodProfileIga = [650,620,652]
    // let completeFoodProfileC3d = [616,618,646]
    // let gutZoomer = [186,187,188]
    // let completeNeuroTHormoneMetabolites = [194,193]
    // let remainingDesc = []

    // let allDescInDbsPanel = [completeFoodProfileIga,completeFoodProfileC3d,gutZoomer,completeNeuroTHormoneMetabolites]

    // let remainingNewValuesWithoutDesc = remainingNewValues.filter(x => ![620,650,652,616,618,646,186,187,188,193,194].includes(x))

    // for(let i = 0;i < allDescInDbsPanel.length; i++) {
    //   if(allDescInDbsPanel[i].filter(x => remainingNewValues.includes(x)).length > 1) {
    //     // remainingNewValuesWithoutDesc.push(allDescInDbsPanel[i].filter(x => remainingNewValues.includes(x)))
    //     // remainingDesc.push(...allDescInDbsPanel[i].filter(x => remainingNewValues.includes(x)))
    //   } else {
    //     remainingNewValuesWithoutDesc.push(...allDescInDbsPanel[i].filter(x => remainingNewValues.includes(x)))
    //   }
    // }

    let remainingTestsa = []
    for (let i = 0; i < remainingNewValues.length; i++) {
      const matchedTest = vaTestList.concat(vwTestList)
        .find((p) => p.id === remainingNewValues[i]);
      if (matchedTest) {
        remainingTestsa.push({...matchedTest, price: isHeavyMetalSpecialPrice && matchedTest.id === HEAVY_METAL_TEST_ID ? HEAVY_METAL_SPECIAL_PRICE : matchedTest.price })
      }
    }
    remainingNewValues = remainingTestsa.sort((a, b) => b.price - a.price).map(i => i.id)
    
    let excludedTestsfor3For7005For1000 = remainingNewValues.filter(x => !anyThreePromoTestIds.includes(x))
    remainingNewValues = remainingNewValues.filter(x => anyThreePromoTestIds.includes(x))

    if(remainingNewValues.length === ANY_THREE_QUANTITY) {
      if(remainingTestsa.map(i => i.price).reduce((prev,curr) => prev + curr, 0) < anyThreePromoPrice) {
        console.log('return')
      } else {
        suggestion.appliedBundles.push({
          bundleId: anyThreePromo.bundleId,
          name: "plan and save test",
          finalPrice: anyThreePromoPrice,
          appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
          appliedSupplement: [],
          quantity: ANY_THREE_QUANTITY
        })
        suggestion.remainingNewValues = []
      }
    }

    if(remainingNewValues.length === ANY_THREE_QUANTITY + 1) {
      if(remainingTestsa.map(i => i.price).reduce((prev,curr) => prev + curr, 0) - remainingTestsa[3].price < anyThreePromoPrice) {
        console.log('return')
      } else {
        suggestion.appliedBundles.push({
          bundleId: anyThreePromo.bundleId,
          name: "plan and save test",
          finalPrice: anyThreePromoPrice,
          appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
          appliedSupplement: [],
          quantity: ANY_THREE_QUANTITY
        })
        suggestion.remainingNewValues = [remainingNewValues[ANY_THREE_QUANTITY]]
      }
    }

    if(remainingNewValues.length === ANY_FIVE_QUANTITY) {
      if(remainingTestsa.slice(0, ANY_THREE_QUANTITY).map(i => i.price).reduce((prev,curr) => prev + curr, 0) < anyThreePromoPrice) {
        // return
      }
      else if(remainingTestsa.slice(ANY_THREE_QUANTITY).map(i => i.price).reduce((prev,curr) => prev + curr, 0) + anyThreePromoPrice < anyFivePromoPrice) {
        suggestion.appliedBundles.push({
          bundleId: anyThreePromo.bundleId,
          name: "plan and save test",
          finalPrice: anyThreePromoPrice,
          appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
          appliedSupplement: [],
          quantity: ANY_THREE_QUANTITY
        })
        suggestion.remainingNewValues = remainingNewValues.slice(ANY_THREE_QUANTITY)
      }
      else {
        suggestion.appliedBundles.push({
          bundleId: anyFivePromo.bundleId,
          name: "plan and save test",
          finalPrice: anyFivePromoPrice,
          appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
          appliedSupplement: [],
          quantity: ANY_FIVE_QUANTITY
        })
        suggestion.remainingNewValues = []
      }
    }

    if(remainingNewValues.length === ANY_THREE_QUANTITY * 2) {
      let oneAny5Price = remainingTestsa[ANY_FIVE_QUANTITY].price + anyFivePromoPrice
      let twoAny3Price = anyThreePromoPrice * 2
      let indvdTestTotalPrice = remainingTestsa.map(i => i.price).reduce((prev,curr) => prev + curr, 0) 
      let first3IndvdTestTotalPrice = remainingTestsa.map(i => i.price).slice(0, ANY_THREE_QUANTITY).reduce((prev,curr) => prev + curr, 0) 
      let oneAny3Price = anyThreePromoPrice + first3IndvdTestTotalPrice

      if(indvdTestTotalPrice < oneAny5Price && indvdTestTotalPrice < twoAny3Price) {
        console.log('return')
      } else {
        if(oneAny5Price <= twoAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyFivePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyFivePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_FIVE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_FIVE_QUANTITY)
        } 
        else if( oneAny3Price < twoAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_THREE_QUANTITY)
        }
        else {
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_THREE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = []
        }
      }
    }

    if(remainingNewValues.length === ANY_FIVE_QUANTITY + ANY_THREE_QUANTITY - 1) { 
      let oneAny5Price = remainingTestsa[ANY_FIVE_QUANTITY].price + remainingTestsa[ANY_FIVE_QUANTITY+1].price + anyFivePromoPrice
      let twoAny3Price = remainingTestsa[ANY_FIVE_QUANTITY+1].price + anyThreePromoPrice * 2
      let indvdTestTotalPrice = remainingTestsa.map(i => i.price).reduce((prev,curr) => prev + curr, 0) 

      if(indvdTestTotalPrice < twoAny3Price && indvdTestTotalPrice < oneAny5Price) {
        console.log('return')
      }
      else {
        if(oneAny5Price <= twoAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyFivePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyFivePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_FIVE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_FIVE_QUANTITY)
        } else {
          suggestion.appliedBundles.push({
          bundleId: anyThreePromo.bundleId,
          name: "plan and save test",
          finalPrice: anyThreePromoPrice,
          appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
          appliedSupplement: [],
          quantity: ANY_THREE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_THREE_QUANTITY, ANY_THREE_QUANTITY * 2),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_THREE_QUANTITY * 2)
        }
      }
    }

    if(remainingNewValues.length === ANY_FIVE_PLUS_THREE) {
      let oneAny5Price = remainingTestsa[ANY_FIVE_QUANTITY].price + remainingTestsa[ANY_FIVE_QUANTITY+1].price + remainingTestsa[ANY_FIVE_QUANTITY+2].price + anyFivePromoPrice
      let twoAny3Price = remainingTestsa[ANY_FIVE_QUANTITY+1].price + remainingTestsa[ANY_FIVE_QUANTITY+2].price + anyThreePromoPrice * 2
      let indvdTestTotalPrice = remainingTestsa.map(i => i.price).reduce((prev,curr) => prev + curr, 0) 

      if(indvdTestTotalPrice < oneAny5Price && indvdTestTotalPrice < twoAny3Price) {
        // return
      } else {
        if(oneAny5Price > (anyFivePromoPrice+anyThreePromoPrice) && twoAny3Price > anyFivePromoPrice+anyThreePromoPrice) {
          suggestion.appliedBundles.push({
            bundleId: anyFivePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyFivePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_FIVE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = []
        }
        else if(oneAny5Price <= twoAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyFivePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyFivePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_FIVE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_FIVE_QUANTITY)
        } else {
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_THREE_QUANTITY, ANY_THREE_QUANTITY * 2),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_THREE_QUANTITY * 2)
        }
      }
    }

    if(remainingNewValues.length === ANY_FIVE_PLUS_THREE + 1) { 
      let oneAny5Price = remainingTestsa[ANY_FIVE_QUANTITY].price + remainingTestsa[ANY_FIVE_QUANTITY+1].price + remainingTestsa[ANY_FIVE_QUANTITY+2].price + remainingTestsa[ANY_FIVE_QUANTITY+3].price + anyFivePromoPrice
      let twoAny3Price = remainingTestsa[ANY_FIVE_QUANTITY+1].price + remainingTestsa[ANY_FIVE_QUANTITY+2].price + remainingTestsa[ANY_FIVE_QUANTITY+3].price + anyThreePromoPrice * 2
      let threeAny3Price = anyThreePromoPrice * 3
      let indvdTestTotalPrice = remainingTestsa.map(i => i.price).reduce((prev,curr) => prev + curr, 0) 

      let oneAny5PriceOneAny3Price =  remainingTestsa[ANY_FIVE_QUANTITY+ANY_THREE_QUANTITY].price + anyFivePromoPrice + anyThreePromoPrice

      if(indvdTestTotalPrice < oneAny5Price && indvdTestTotalPrice < twoAny3Price && indvdTestTotalPrice < threeAny3Price) {
        // return
      } else {
        if(oneAny5Price > oneAny5PriceOneAny3Price && threeAny3Price > oneAny5PriceOneAny3Price && twoAny3Price > oneAny5PriceOneAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyFivePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyFivePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_FIVE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_FIVE_QUANTITY, ANY_FIVE_PLUS_THREE),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_FIVE_PLUS_THREE)
        }
        else if(oneAny5Price <= threeAny3Price || oneAny5Price <= twoAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyFivePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyFivePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_FIVE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_FIVE_QUANTITY)
        } 
        else if(threeAny3Price <= twoAny3Price) {
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_THREE_QUANTITY, ANY_THREE_QUANTITY * 2),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_THREE_QUANTITY * 2),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = []
        }
        else {
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(0, ANY_THREE_QUANTITY),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.appliedBundles.push({
            bundleId: anyThreePromo.bundleId,
            name: "plan and save test",
            finalPrice: anyThreePromoPrice,
            appliedZoomers: remainingNewValues.slice(ANY_THREE_QUANTITY, ANY_THREE_QUANTITY * 2),
            appliedSupplement: [],
            quantity: ANY_THREE_QUANTITY
          })
          suggestion.remainingNewValues = remainingNewValues.slice(ANY_THREE_QUANTITY * 2)
        }
      }
    }
    /**
     * comment out following code to prevent multiple 5 for $1000 promo in a single order 
     * ************************
     * 04/30/2025: remove comment, change while to if, and move following code to the end of the function to fix 5 for $1000 promo not being applied
     * and different 5 for $1000 promo combination causing different price issue
     */
    // loop to form any5 promo every time, until remainingNewValues amount is less than 10
    if (remainingNewValues.length >= ANY_FIVE_QUANTITY * 2) {
      suggestion.appliedBundles.push({
        bundleId: anyFivePromo.bundleId,
        name: "plan and save",
        finalPrice: anyFivePromoPrice,
        appliedZoomers: remainingNewValues.slice(0, ANY_FIVE_QUANTITY),
        appliedSupplement: [],
        quantity: ANY_FIVE_QUANTITY
      })
      suggestion.remainingNewValues = remainingNewValues.slice(ANY_FIVE_QUANTITY)
      remainingNewValues = suggestion.remainingNewValues
    }
    suggestion.remainingNewValues = suggestion.remainingNewValues.concat(excludedTestsfor3For7005For1000)
    return suggestion
  })
 
  // calculate the price for every combination and return the cheapest
  let suggestBundleInfoWithPrice = suggestBundleInfo.map((o) => {
    let priceAfterAppliedBundle = [];
    // replace remainingNewValues with parent tests if available
    o.remainingNewValues = replaceWithParentTests(o.remainingNewValues, testNodeList);
    for (let i = 0; i < o.remainingNewValues.length; i++) {
      const matchedTest = vaTestList
        .concat(vwTestList)
        .find((p) => p.id === o.remainingNewValues[i]);
      if (matchedTest) {
        // heavy metal price will update to special price if isHeavyMetalSpecialPrice
        let price = isHeavyMetalSpecialPrice && matchedTest.id === HEAVY_METAL_TEST_ID ? HEAVY_METAL_SPECIAL_PRICE : matchedTest.price;
        priceAfterAppliedBundle.push(price);
      }
    }
    
    for (let j = 0; j < o.appliedBundles.length; j++) {
      priceAfterAppliedBundle.push(o.appliedBundles[j].finalPrice);
    }
    return {
      appliedBundles: o.appliedBundles.map((i) => {
        if (i.quantity) {
          return {
            appliedBundleId: i.bundleId,
            appliedZoomers: i.appliedZoomers,
            appliedSupplement: i.appliedSupplement,
            bundlePrice: i.finalPrice,
          };
        } else {
          return {
            appliedBundleId: i.bundleId,
            bundlePrice: i.finalPrice,
          };
        }
      }),
      remainingNewValues: o.remainingNewValues,
      priceAfterAppliedBundle: _.sum(priceAfterAppliedBundle).toFixed(2),
    };
  });

  // unique key for each bundle comination
  for(let i = 0;i<suggestBundleInfoWithPrice.length;i++) {
    let bundlesKey = suggestBundleInfoWithPrice[i].appliedBundles
      .map(i => i.appliedBundleId)
      .sort((a,b) => a-b)
      .join(",")
    suggestBundleInfoWithPrice[i].bundlesKey = bundlesKey
  }

  // maintain the order of all suggested bundles by unique bundle key
  suggestBundleInfoWithPrice = _.sortBy(suggestBundleInfoWithPrice, 'bundlesKey')

  let cheapestBundleCombination = {}
  if(suggestBundleInfoWithPrice.length > 0) {
    let minPrice = parseInt(suggestBundleInfoWithPrice[0].priceAfterAppliedBundle)
    for(let i = 0;i<suggestBundleInfoWithPrice.length;i++) {
      if(parseInt(suggestBundleInfoWithPrice[i].priceAfterAppliedBundle) <= minPrice) {
        minPrice = parseInt(suggestBundleInfoWithPrice[i].priceAfterAppliedBundle)
        cheapestBundleCombination = suggestBundleInfoWithPrice[i]
      }
    }
  }

  return cheapestBundleCombination;
};